import * as type from '../types';

export function navbarToggler(sidemenu) {
  return {
    type: type.SET_NAVBAR_TOGGLE,
    payload: sidemenu,
  };
}
export function setServerTime(time) {
  return {
    type: type.SET_SERVER_TIME,
    payload: time,
  };
}
export function tickServerTime(time) {
  return {
    type: type.TICK_SERVER_TIME,
    payload: time,
  };
}
